import productsApi from "@/api/product";

const state = {
    isLoading: false,
    isMore: null,
    nextPage: 1,
    products: null,
}
export const mutationTypes = {
    clearProducts: '[products_wishlist] clearProducts',
    appendProducts: '[products_wishlist] appendProducts',
    removeProduct: '[products_wishlist] removeProduct',
    setIsLoading: '[products_wishlist] setIsLoading',
    setIsMore: '[products_wishlist] setIsMore',
    setNextPage: '[products_wishlist] setNextPage'
}
export const actionTypes = {
    getProducts: '[products_wishlist] getProducts',
}

export const getterTypes = {
    products: '[products_wishlist] products',
    isLoading: '[products_wishlist] isLoading',
    isMore: '[products_wishlist] isMore'
}
const mutations = {
    [mutationTypes.appendProducts](state, orders) {
        if (state.products === null){
            const arrProxy = new Proxy(orders, {
              get(target, prop) {
                if (prop === 'push') {
                  return (...args) => {
                    console.log(...args);
                    return target[prop](...args);
                  };
                }
                return target[prop];
              }
            });
            state.products = arrProxy
        } else {
            orders.forEach((order) => {
                const found = state.products.find((element) => element.id === order.id);
                if (!found){
                    state.products.push(order)
                }
            })
        }
    },
    [mutationTypes.removeProduct](state, product_id) {
        const index = state.products.findIndex(element => element.id === product_id);
        if (index > -1) {
            state.products.splice(index, 1);
            let name = 'wishlist'
            let cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';');
                for (let i = 0; i < cookies.length; i++) {
                    const cookie = cookies[i].trim();
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            let wishlist = cookieValue
            console.log("Wishlist", wishlist)

            let date = new Date();
            date.setMonth(date.getMonth() + 3);

            if (wishlist !== null){
                console.log( wishlist.split(","));

                wishlist = wishlist.split(",");
                if (wishlist[0] === ''){
                    wishlist = []
                }
                let index = wishlist.indexOf(product_id.toString());
                if (index > -1) { //if found
                  wishlist.splice(index, 1);
                }
            }

            wishlist = Array.from(new Set(wishlist));
            document.cookie = "wishlist=" + wishlist.join(',') + "; path=/; expires=" + date.toUTCString();
        }
    },
    [mutationTypes.clearProducts](state){
        state.products = null
        state.nextPage = 1
        state.isMore = null
    },
    [mutationTypes.setIsLoading](state, value){
        state.isLoading = value
    },
    [mutationTypes.setIsMore](state, value){
        state.isMore = value
    },
    [mutationTypes.setNextPage](state, value){
        state.nextPage = value
    }
}

const getters = {
    [getterTypes.products]: state => {
        return state.products
    },
    [getterTypes.isLoading]: state => {
        return state.isLoading
    },
    [getterTypes.isMore]: state => {
        return state.isMore
    }
}

const actions = {
    [actionTypes.getProducts](context) {
        context.commit(mutationTypes.setIsLoading, true)
        let credentials = {}
        if (state.nextPage){
            credentials.page = state.nextPage
        }
        return new Promise(resolve => {
            productsApi
                .getProductsWishlist(credentials)
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.appendProducts, response.data['results'])
                    context.commit(mutationTypes.setIsLoading, false)

                    if (response.data['next']){
                        context.commit(mutationTypes.setIsMore, true)
                        const url = new URL(response.data['next']);
                        const urlParams = new URLSearchParams(url.search);
                        const nextPage = parseInt(urlParams.get('page'))
                        context.commit(mutationTypes.setNextPage, nextPage)
                        console.log('Next page:', nextPage)
                    } else {
                        context.commit(mutationTypes.setNextPage, null)
                        context.commit(mutationTypes.setIsMore, false)
                    }
                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}